import * as api from '../../api'
import { Notification } from 'element-ui';
const logs = {
  state: {
    operateLos: [],
    auditLogs: [],
    commentList: [],
    sortFormInfo: [],
    newsTopicInfoData: '',
    historyRecordList: [],
    relatedMatters: []
  },
  mutations: {
    SET_OPERATELOGS_DATA: (state, value) => {
      state.operateLos = value
    },
    SET_AUDITLOGS_DATA: (state, value) => {
      state.auditLogs = value
    },
    SET_COMMENTLIST_DATA: (state, value) => {
      state.commentList = value
    },
    SET_SORTFORMINFO_DATA: (state, value) => {
      state.sortFormInfo = value
    },
    SET_NEWSTOPICINFO_DATA: (state, obj) => {
      state.newsTopicInfoData = obj
    },
    SET_HISTORY_RECORD: (state, value) => {
      state.historyRecordList = value
    },
    SET_RELATED_MATTERS: (state, value) => {
      state.relatedMatters = value
    }

  },
  actions: {
    //获取操作日志列表
    GET_OPERATELOG_DATA: (context, option) => {
      return api._post(_API_ + 'api/article/log/operation/get_log_article', option).then((resp) => {
        if (resp.code == 200) {
          context.commit('SET_OPERATELOGS_DATA', resp.data)
        } else {
          context.commit('SET_OPERATELOGS_DATA', [])
        }
      }).catch((error) => {
        console.log(error)

      })
    },


    //获取审核日志
    GET_AUDIT_LOGLIST: (context, option) => {
      return api._post(_API_ + 'api/article/audit/audit_logs', option).then((resp) => {
        if (resp.code == 200) {
          context.commit('SET_AUDITLOGS_DATA', resp.data)
        } else {
          context.commit('SET_AUDITLOGS_DATA', [])
        }
      }).catch((error) => {
        console.log(error)

      })
    },


    //获取评论列表
    GET_ARTICLE_COMMENTS: (context, option) => {
      return api._post(_API_ + 'api/article/utils/get_comment', option).then((resp) => {
        if (resp.code == 200) {
          if (resp.data) {
            context.commit('SET_COMMENTLIST_DATA', resp.data)
          }
        } else {
          context.commit('SET_COMMENTLIST_DATA', [])
        }
      }).catch((error) => {
        console.log(error)
      })
    },


    //获取串联单信息
    GET_SORTFORM_INFODATA: (context, option) => {
      context.commit('SET_SORTFORMINFO_DATA', [])
      return api._post(_TEMPORARYURL_ + 'sort_form/get_article_sort_form', option).then((resp) => {
        if (resp.code == 200) {
          if (resp.data) {
            context.commit('SET_SORTFORMINFO_DATA', resp.data)
          }

        } else {
          context.commit('SET_SORTFORMINFO_DATA', [])
        }
      }).catch((error) => {
        console.log(error)
      })
    },

    //获取报题信息数据
    GET_NEWSTOPIC_INFODATA: (context, option) => {
      context.commit('SET_NEWSTOPICINFO_DATA', '')
      return api._post(_API_ + 'api/article/news_topic/by_id', option).then((resp) => {
        if (resp.code == 200) {
          context.commit('SET_NEWSTOPICINFO_DATA', resp.data)
        } else {
          context.commit('SET_NEWSTOPICINFO_DATA', '')
        }
      }).catch((error) => {
        console.log(error)
      })
    },

    //获取留痕记录
    GET_HISTORY_RECORD: (context, id) => {
      return api._get(_DIFFURL_ + 'api/diff/action?docid=' + id, '').then((resp) => {
        if (resp.code == 200) {
          context.commit('SET_HISTORY_RECORD', resp.data.list)
        } else {
          context.commit('SET_HISTORY_RECORD', [])
        }
      }).catch((error) => {
        console.log(error)
      })
    },

    //获取关联素材
    GET_RELATED_MATTER: (context, option) => {
      context.commit('SET_RELATED_MATTERS', '')
      return api._post(_IMGFILEURL_ + 'public/getRelationMaterial', option).then((resp) => {
        if (resp.code == 200) {
          context.commit('SET_RELATED_MATTERS', resp.data)
        } else {
          context.commit('SET_RELATED_MATTERS', '')
        }
      }).catch((error) => {
        console.log(error)
      })
    },






  }
}

export default logs
